export default __webpack_public_path__ + "static/media/contact.47f3279f.png";